import { useEffect, useState } from 'react'
import { AppRoutes } from '@/routes/AppRoutes'
import { useAuthStore } from '@/store/authStore'
import { supabase, supabaseConfigured } from '@/lib/supabase'
import { Loader } from '@/components/common/Loader'

export default function App() {
  const ready = useAuthStore((s) => s.ready)
  const bootstrap = useAuthStore((s) => s.bootstrap)
  const setSession = useAuthStore((s) => s.setSession)

  // Absolute hard fallback. The bootstrap() call already races against its
  // own 4-second timeout, but this is a second safety net: under no
  // circumstances should the user see "Loading Radiance…" for more than 8
  // seconds. If something pathological happens (e.g. an unhandled rejection
  // in Supabase's internals), we force-render the app and let the user
  // interact with the login page directly.
  const [forceReady, setForceReady] = useState(false)

  useEffect(() => {
    bootstrap()
    const fallback = setTimeout(() => setForceReady(true), 8000)

    let subscription
    if (supabaseConfigured) {
      try {
        const { data } = supabase.auth.onAuthStateChange((_event, session) => {
          setSession(session)
        })
        subscription = data?.subscription
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[Radiance] Failed to subscribe to auth changes:', err)
      }
    }

    return () => {
      clearTimeout(fallback)
      subscription?.unsubscribe?.()
    }
  }, [bootstrap, setSession])

  if (!ready && !forceReady) {
    return (
      <div className="grid min-h-screen place-items-center bg-paper">
        <Loader label="Loading Radiance…" />
      </div>
    )
  }

  return <AppRoutes />
}
